import { useMemo } from 'react'
import { QuestionType, UseFileUpload } from '@factorialco/f0-react'
import { FormDetailDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useQuery } from 'modules/core/hooks/useQuery'

import { FromFragmentToQuestionnaire } from './helpers'
import { AgentStateType, QuestionnaireType, ValidationResult } from './types'
import { FormEditor, FormEditorLabels } from './form'

const defaultQuestionnaire: QuestionnaireType = {
  title: '',
  description: '',
  elements: [],
}

interface Props {
  id?: string
  resourceType: string
  formType?: AgentStateType['formType']
  allowedQuestionTypes?: QuestionType[]
  useUpload?: UseFileUpload
  labels?: FormEditorLabels
  requiredSkills?: string[]
  validate?: (questionnaire: QuestionnaireType) => ValidationResult
}

const NewFormEditor = ({
  id,
  resourceType,
  formType,
  allowedQuestionTypes,
  useUpload,
  labels,
  requiredSkills,
  validate,
}: Props) => {
  const { data: formData, loading: loadingForm } = useQuery(FormDetailDocument, {
    variables: { id: id ?? '', resourceType },
    skip: !id,
  })

  const form = formData?.forms?.form ?? null

  const initialQuestionnaire = useMemo(
    () => (form ? FromFragmentToQuestionnaire(form) : defaultQuestionnaire),
    [form]
  )

  if (id && loadingForm) {
    return <Loading expand />
  }

  return (
    <FormEditor
      form={form}
      initialQuestionnaire={initialQuestionnaire}
      resourceType={resourceType}
      formType={formType}
      allowedQuestionTypes={allowedQuestionTypes}
      useUpload={useUpload}
      labels={labels}
      requiredSkills={requiredSkills}
      validate={validate}
    />
  )
}

export default NewFormEditor
